module.exports = __webpack_public_path__ + "static/img/2-4.718b331.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-center/my-focus/2-4.jpg
// module id = MtnX
// module chunks = 1